function hideMobileAdWhenFooterVisible() {
  const footer = document.querySelector('footer.wp-block-template-part');
  const ad = document.querySelector('footer .mpa-slot--layout_fixed_mobile');
  if (!footer || !ad) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          ad.classList.add('hide-mobile-ad');
        } else {
          ad.classList.remove('hide-mobile-ad');
        }
      });
    },
    { threshold: 0 },
  );

  observer.observe(footer);
}

export { hideMobileAdWhenFooterVisible };
